import type { ReactElement } from 'react';
import React, { useId } from 'react';
import styled from 'styled-components';

import AlertHelp from '@rover/icons/svg/alert-help.svg';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

import Tooltip, { Props as TooltipProps } from '../Tooltip';

type Props = {
  icon?: SvgIcon;
  text: string;
} & TooltipProps;

type IconProps = {
  role: string;
  tabIndex: number;
  'aria-describedby': string;
};

export const IconWrapper = styled.span<Record<string, unknown>>`
  svg {
    fill: ${({ theme }) => theme.textColor.primary};
    height: 16px;
    vertical-align: middle;
    width: 16px;
  }
`;

const renderIconComponent = (IconComponent: SvgIcon, iconProps: IconProps): ReactElement | null => {
  if (!IconComponent) {
    return null;
  }

  return (
    <IconWrapper>
      <IconComponent {...iconProps} data-testid="something" />
    </IconWrapper>
  );
};

const IconTooltip = ({ icon = AlertHelp, text, ...other }: Props): ReactElement => {
  const tooltipId = useId();
  const iconProps: IconProps = {
    role: 'image',
    tabIndex: 0,
    'aria-describedby': tooltipId,
  };

  return (
    <Tooltip id={tooltipId} text={text} toggleOnFocusOrBlur {...other} data-testid="hello2">
      {renderIconComponent(icon, iconProps)}
    </Tooltip>
  );
};

export default IconTooltip;
